import { render } from "./TodayPatientsV1.vue?vue&type=template&id=0887db73&scoped=true"
import script from "./TodayPatientsV1.vue?vue&type=script&lang=js"
export * from "./TodayPatientsV1.vue?vue&type=script&lang=js"

import "./TodayPatientsV1.vue?vue&type=style&index=0&id=0887db73&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0887db73"]])

export default __exports__